<template>
  <div class="w100" style="heixxght: 60vw; ">
    <div class="car-container" layout="column top-center">
      <img src="/static/images/cars.png"/>
      <div ref="info" class="info">
        <span class="desktop" v-html="parseText()"></span>
        <span class="mobile" v-html="parseTextMobile()"></span>
      </div>
    </div>

  </div>
</template>

<script>

  export default {
    name: "Cars",
    components: {},
    props: ['value', 'valueMobile'],
    methods: {
      parseText() {
        return this.value.split('\n').join('<br>');
      },
      parseTextMobile() {
        const text = this.valueMobile == '' ? this.value : this.valueMobile;
        return text.split('\n').join('<br>');
      }
    },
    activated() {
      console.log('cars activated!');
    }
  }
</script>

<style lang="scss" scoped>

  .car-container {
    width: 100%;
    position: relative;
    font-size: 1rem;
    height: 100%;
    margin-top: 2rem;

  }

  img {
    width: 85vw;
    max-width: 1200px;
    min-width: 330px;

  }

  a {
    color: white;
  }

  .info {
    position: relative;
    margin-top: -18vw;

    @media screen and (min-width: 1400px) {
      margin-top: -250px;
    }

    width:100%;

    //max-width:400px;
    //min-width:calc(90%);
   // float:right;

    /*@media screen and (min-width: 1400px) {
      //margin-top: -30%;
    }
    @media screen and (max-width: 600px) {
      //margin-top: -20%;
    }

    @media screen and (max-width: 350px) {
     // margin-top: -15%;
    }*/

  }

  $min-width: 500px;

  .mobile {
    @media screen and (min-width: $min-width) {
      display: none;
    }
  }

  .desktop {
    @media screen and (max-width: $min-width) {
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/blocks/Cars.vue